import axios from "axios";
import API from "./API";
import Endpoints from "@/V3/Config/Endpoints";

export default {
    list: function (centreId) {
        return axios.get(
            API.url(Endpoints.Inventories.List, {centre_id: centreId})
        ).then((res) => {
            return res.data.inventories;
        });
    }
}
